import React from 'react';
import { Helmet } from 'react-helmet';

import SEO from '../../components/SEO';

const PresentationPageRedirect = () => (
  <>
    <SEO
      title="Demo Day | DeepReturn"
      canonical="/demo_day_presentation/"
      indexPage={false}
    />
    <Helmet>
      <meta httpEquiv="refresh" content="0;url=/demo_day_presentation/" />
    </Helmet>
  </>
);

export default PresentationPageRedirect;
